import * as Yup from "yup";
import R from "ramda";

export const initialValues = (name = null) => {
  return {
    name: R.isNil(name) ? "" : name,
  };
};

export const validationSchema = Yup.object({
  name: Yup.string().max(70, "Not a valid name"),
});
